// extracted by mini-css-extract-plugin
module.exports = {"top-large":"VerticalPadding_top-large__Fdv3J","top-medium":"VerticalPadding_top-medium__8WZul","bottom-large":"VerticalPadding_bottom-large__W6wnm","bottom-medium":"VerticalPadding_bottom-medium__T9Qsp"};
module.exports.__checksum = "fd5a6a28f19c"
